import { render, staticRenderFns } from "./AdsSubcategoriesList.vue?vue&type=template&id=1a0afcec&scoped=true&"
import script from "./AdsSubcategoriesList.vue?vue&type=script&lang=js&"
export * from "./AdsSubcategoriesList.vue?vue&type=script&lang=js&"
import style0 from "./AdsSubcategoriesList.vue?vue&type=style&index=0&id=1a0afcec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0afcec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
